import styled from 'styled-components';
import DatePicker from 'react-datepicker';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px 20px;
  font-family:"Avenir Next LT W01 Demi";
`;

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  position: relative;
`;

export const InputContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  height: 36px;
  font-family: "AvenirNextLTW01-Regular";
  font-weight: 400;
`;

export const Input = styled.input`
  width: 100%;
  height: 100%;
  outline: none;
  padding: 0 30px 0 10px;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  height: 36px;
  transition: border-color .3s ease;
  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth}px;` : '')}
`;

export const DatePickerInput = styled(DatePicker)`
  width: 100%;
  height: 100%;
  outline: none;
  padding: 0 30px 0 10px;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  height: 36px;
  transition: border-color .3s ease;
  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth}px;` : '')}
  `;

export const Label = styled.label`
  font-family: "AvenirNextLTW01-Regular";
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  margin-top: 10px;
  padding-right: 25px;
`;

export const Checkbox = styled.input`
  margin-right: 5px;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const SelectorImage = styled.img`
  margin-bottom: 3px;
`;

export const RadioContainer = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const RadioContainerMargin = styled(RadioContainer)`
  margin-bottom: 15px;
`;

export const TextboxContainer = styled.div`
  height: unset;
  position: relative;
  display: flex;
  align-items: center;
`;

export const TextboxInput = styled.textarea`
  padding-top: 8px;
  width: 100%;
  height: 124px;
  margin: 0px;
  outline: none;
  padding: 10px 30px 0 10px;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  transition: border-color .3s ease;
  font-family: "AvenirNextLTW01-Regular";
  font-weight: 400;
`;
